import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../data/api';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await loginUser(username, password);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      if (onLogin) onLogin(res.data.user);
      navigate('/heatmap');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundImage: 'url(/assets/img/login_bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
      position: 'relative'
    }}>
      {/* Dark overlay for readability */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(15, 23, 42, 0.75)',
        pointerEvents: 'none'
      }} />

      <div style={{
        width: '100%', maxWidth: 420, padding: '0 20px', position: 'relative', zIndex: 1
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            background: '#fff', borderRadius: 16, padding: '12px 24px',
            display: 'inline-block', marginBottom: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.15)'
          }}>
            <img
              src="/assets/img/amscl_logo.png"
              alt="AMSCL Logo"
              style={{ height: 56, objectFit: 'contain' }}
            />
          </div>
          <h2 style={{
            color: '#fff', fontSize: '1.3rem', fontWeight: 700, margin: '8px 0 4px',
            letterSpacing: '0.5px'
          }}>
            Logistic Management
          </h2>
          <p style={{ color: '#94a3b8', fontSize: '.85rem', margin: 0 }}>
            Information System (LMIS)
          </p>
        </div>

        {/* Login Card */}
        <div style={{
          background: '#fff', borderRadius: 16, padding: '36px 32px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}>
          <h3 style={{
            margin: '0 0 6px', fontSize: '1.25rem', fontWeight: 700, color: '#1e293b'
          }}>
            Sign In
          </h3>
          <p style={{ color: '#64748b', fontSize: '.82rem', margin: '0 0 24px' }}>
            Enter your credentials to access the dashboard
          </p>

          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8,
              padding: '10px 14px', marginBottom: 16, color: '#b91c1c',
              fontSize: '.82rem', fontWeight: 500
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 18 }}>
              <label style={{
                display: 'block', fontSize: '.78rem', fontWeight: 600,
                color: '#475569', marginBottom: 6, textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                required
                autoFocus
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: 8,
                  border: '2px solid #e2e8f0', fontSize: '.9rem',
                  outline: 'none', transition: 'border-color 0.2s',
                  boxSizing: 'border-box', background: '#f8fafc'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{
                display: 'block', fontSize: '.78rem', fontWeight: 600,
                color: '#475569', marginBottom: 6, textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Password
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                  style={{
                    width: '100%', padding: '11px 42px 11px 14px', borderRadius: 8,
                    border: '2px solid #e2e8f0', fontSize: '.9rem',
                    outline: 'none', transition: 'border-color 0.2s',
                    boxSizing: 'border-box', background: '#f8fafc'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: '#94a3b8', fontSize: '.85rem', padding: 4
                  }}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '12px', borderRadius: 8, border: 'none',
                background: loading ? '#94a3b8' : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
                color: '#fff', fontSize: '.95rem', fontWeight: 700,
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s', letterSpacing: '0.5px'
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
};

export default Login;
